import { StyleSheet, type TextStyle, type ViewStyle } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { CUSTOMIZER_SURFACE } from './characterCustomizer.constants';

export const getPickerModeToggleStyles = (theme: Theme) =>
  StyleSheet.create({
    track: {
      flexDirection: 'row',
      alignSelf: 'center',
      backgroundColor: CUSTOMIZER_SURFACE.iconBtnBg,
      borderRadius: 9999,
      padding: 3,
    },
    segment: {
      paddingHorizontal: 16,
      paddingVertical: 7,
      borderRadius: 9999,
    },
    segmentActive: {
      backgroundColor: theme.primary,
    },
    segmentText: {
      fontSize: 13,
      fontWeight: '700',
      color: theme.gray[500],
    },
    segmentTextActive: {
      color: theme.onPrimary,
    },
  });

type PickerModeToggleStyles = ReturnType<typeof getPickerModeToggleStyles>;

export function getSegmentStyle(styles: PickerModeToggleStyles, active: boolean): ViewStyle[] {
  return active ? [styles.segment, styles.segmentActive] : [styles.segment];
}

export function getSegmentTextStyle(styles: PickerModeToggleStyles, active: boolean): TextStyle[] {
  return active ? [styles.segmentText, styles.segmentTextActive] : [styles.segmentText];
}
